import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "FacilityMaintenanceVendorTypesTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no vendor categories to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching vendor categories found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "facility_maintenance_vendor_types"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "name"
				},
				{
					text: "# of Vendors",
					value: "vendors.length"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteVendorType( vendorType ) {
			const deleteIndex = this.items.findIndex( item => vendorType.id === item.id );

			return vendorType.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "facilityMaintenanceVendorType",
								params: { idVendorType: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete vendor category" )}
								onConfirm={() => this.deleteVendorType( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Vendor Category"
							>
								Are you sure you want to delete the maintenance vendor category <strong>{item.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
